import { useMutation } from 'react-query'

import { APIError } from '../../../../../../../utils'
import { deleteAdditionalField } from '../../../query-api'

interface UseDeleteAdditionalFieldProps {
  onError?: (error?: APIError) => void
  onSettled?: (data: void, error: APIError | null | undefined) => void
  onSuccess?: (data: void) => void
}

export const useDeleteAdditionalField = (props?: UseDeleteAdditionalFieldProps) => {
  const { onError, onSuccess, onSettled } = props || {}
  const { mutate, ...rest } = useMutation(deleteAdditionalField, {
    onError,
    onSuccess,
    onSettled,
  })

  return { delete: mutate, ...rest }
}
